<template>
  <v-dialog
    persistent
    v-model="dialog"
    max-width="600px"
    content-class="bra-20"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
        :color="(active) ? 'primary': ''"
      >
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Parâmetros do produto

        <v-spacer />

        <v-btn icon @click="fecharDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-3 pb-0">
        <p class="my-1"><strong>Filial: </strong> {{produto.filial}}</p>
        <p class="mb-5"><strong>Produto: </strong> {{ `${produto.idproduto} - ${produto.descricao_produto}`}}</p>

        <text-field-formatador
          v-model="configProduto.cobertura_estoque"
          label="Cobertura de Estoque*"
          :max-digitos="4"
          remover-valor-irrelevante
          outlined
          :error-messages="coberturaEstoqueErrors"
          @input="$v.configProduto.cobertura_estoque.$touch()"
          @blur="$v.configProduto.cobertura_estoque.$touch();verificaValoresValidos()"
          @focus="$event.target.select()"
        />

        <text-field-formatador
          v-model="configProduto.estoque_min"
          label="Estoque Mínimo*"
          :max-digitos="4"
          remover-valor-irrelevante
          outlined
          :error-messages="estoqueMinErrors"
          @input="$v.configProduto.estoque_min.$touch()"
          @blur="$v.configProduto.estoque_min.$touch();verificaValoresValidos()"
          @focus="$event.target.select()"
        />

        <text-field-formatador
          v-model.number="configProduto.estoque_max"
          label="Estoque Máximo Distribuição*"
          :max-digitos="4"
          remover-valor-irrelevante
          outlined
          :error-messages="estoqueMaxErrors"
          @input="$v.configProduto.estoque_max.$touch()"
          @blur="$v.configProduto.estoque_max.$touch();verificaValoresValidos()"
          @focus="$event.target.select()"
        />

        <text-field-formatador
          v-model="configProduto.multiplo_dist"
          label="Múltiplo de Distribuição*"
          :max-digitos="4"
          remover-valor-irrelevante
          outlined
          :error-messages="multiploDistribuicaoErrors"
          @input="$v.configProduto.multiplo_dist.$touch()"
          @blur="$v.configProduto.multiplo_dist.$touch();verificaValoresValidos()"
          @focus="$event.target.select()"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn class="mr-4 ml-n2" color="primary" text @click="atualizarConfigProduto()">
          salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import TextFieldFormatador from '../../utils/TextFieldFormatadorDeValor'
import DrpAPI from '../../../api/drp.js'

export default {
  name: 'ConfigDIstribuicaoProdutoDialog',
  components: {TextFieldFormatador},
  props: {
    produto: {
      type: Object,
      required: true
    },
    active: Boolean
  },
  data: () => ({
    dialog: false,
    configProduto: {
      filial: '',
      idproduto: '',
      cobertura_estoque: '',
      estoque_min: '',
      estoque_max: '',
      multiplo_dist: '',
    }
  }),
  validations: {
    configProduto: {
      cobertura_estoque: {
        // required,
        minValue: minValue(0)
      },
      estoque_min: {
        // required,
        minValue: minValue(0),
        // quantidade() {
        //   const estoque_max = parseFloat(this.configProduto.estoque_max);
        //   const estoque_min = parseFloat(this.configProduto.estoque_min);
        //   return estoque_min <= estoque_max || estoque_max === 0
        // }
      },
      estoque_max: {
        // required,
        minValue: minValue(0),
        // quantidade() {
        //   const estoque_max = parseFloat(this.configProduto.estoque_max);
        //   const estoque_min = parseFloat(this.configProduto.estoque_min);
        //   return estoque_max === 0 || estoque_max >= estoque_min
        // }
      },
      multiplo_dist: {required, minValue: minValue(0.0001)}
    }
  },
  computed: {
    coberturaEstoqueErrors() {
      const errors = [];
      if (!this.$v.configProduto.cobertura_estoque.$dirty) return errors;
      // !this.$v.configProduto.cobertura_estoque.required && errors.push("O valor é obrigatório.");
      !this.$v.configProduto.cobertura_estoque.minValue && errors.push("Valor mínimo é 0.");
      return errors;
    },
    estoqueMinErrors() {
      const errors = [];
      if (!this.$v.configProduto.estoque_min.$dirty) return errors;
      // !this.$v.configProduto.estoque_min.required && errors.push("O valor é obrigatório.");
      !this.$v.configProduto.estoque_min.minValue && errors.push("Valor mínimo é 0.");
      // !this.$v.configProduto.estoque_min.quantidade && errors.push("Valor mínimo deve ser menor que o valor máximo.");
      return errors;
    },
    estoqueMaxErrors() {
      const errors = [];
      if (!this.$v.configProduto.estoque_max.$dirty) return errors;
      // !this.$v.configProduto.estoque_max.required && errors.push("O valor é obrigatório.");
      !this.$v.configProduto.estoque_max.minValue && errors.push("Valor mínimo é 0.");
      // !this.$v.configProduto.estoque_max.quantidade && errors.push("Valor máximo deve ser maior que o valor mínimo.");
      return errors;
    },
    multiploDistribuicaoErrors() {
      const errors = [];
      if (!this.$v.configProduto.multiplo_dist.$dirty) return errors;
      !this.$v.configProduto.multiplo_dist.required && errors.push("O valor é obrigatório.");
      !this.$v.configProduto.multiplo_dist.minValue && errors.push("Valor mínimo é 0,0001.");
      return errors;
    },
  },
  watch: {
    dialog (novoValor) {
      novoValor && this.buscarConfigPorduto()
    }
  },
  methods: {
    fecharDialog () {
      this.dialog = false
    },
    verificaValoresValidos () {
      if (!this.configProduto.cobertura_estoque) this.configProduto.cobertura_estoque = 0
      if (!this.configProduto.estoque_max) this.configProduto.estoque_max = 0
      if (!this.configProduto.estoque_min) this.configProduto.estoque_min = 0
    },
    buscarConfigPorduto () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        filial: this.produto.filial,
        idproduto: this.produto.idproduto
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getConfigProduto(headers, params)
          .then(response => {
            const {token, produto} = response.data;
            localStorage.token = token

            if (produto) {
              this.configProduto = {
                filial: produto.filial,
                idproduto: produto.idproduto,
                cobertura_estoque: produto.cobertura_estoque,
                estoque_min: produto.estoque_min,
                estoque_max: produto.estoque_max,
                multiplo_dist: produto.multiplo_dist
              }
            } else {
              this.configProduto = {
                filial: this.produto.filial,
                idproduto: this.produto.idproduto,
                cobertura_estoque: 0,
                estoque_min: 0,
                estoque_max: 0,
                multiplo_dist: 0
              }
            }
          })
          .catch(() => this.Helpers.logout())
      );
    },
    atualizarConfigProduto () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {...this.configProduto};

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.setConfigProduto(headers, params)
            .then(response => {
              const {token} = response.data;
              localStorage.token = token
              this.$emit('update:active', params.cobertura_estoque > 0 || params.estoque_max > 0 || params.estoque_min > 0)
              this.$emit("atualizar-lista-produtos", {})
              this.fecharDialog()
            })
            .catch(() => this.Helpers.logout())
        );
      }
    }
  }
}
</script>

<style scoped>

</style>
